import React from 'react';

const MainFeatures = () => {
  const features = [
    {
      title: "AI-Powered Precision",
      description: "State-of-the-art deep learning models deliver pixel-perfect edge detection and natural background removal results.",
      icon: "🤖",
      color: "blue"
    },
    {
      title: "Lightning-Fast Processing",
      description: "Advanced local processing engine delivers results in milliseconds, powered by WebGPU acceleration technology.",
      icon: "⚡",
      color: "yellow"
    },
    {
      title: "Enterprise-Grade Privacy",
      description: "Zero server uploads, 100% local processing. Your images never leave your device, ensuring complete data privacy.",
      icon: "🔒",
      color: "green"
    },
    {
      title: "Smart Batch Processing",
      description: "Process multiple images simultaneously with intelligent resource allocation for maximum efficiency.",
      icon: "📦",
      color: "purple"
    },
    {
      title: "Professional Output Quality",
      description: "Support for ultra-high resolution images up to 8K, with lossless quality preservation and fine edge details.",
      icon: "✨",
      color: "pink"
    },
    {
      title: "Versatile Export Options",
      description: "Export in PNG with transparency, optimized JPG, or next-gen WEBP format. Custom background replacement available.",
      icon: "💾",
      color: "indigo"
    }
  ];

  return (
    <section id="features" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent sm:text-4xl">
            Enterprise Features, Zero Cost
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-500">
            Experience professional-grade background removal with cutting-edge AI technology, completely free.
          </p>
        </div>

        <div className="mt-20 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="relative p-8 bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-500 transform hover:-translate-y-1 group"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl" />
              <div className="relative z-10">
                <div className="text-4xl mb-6 transform group-hover:scale-110 transition-transform duration-500">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MainFeatures;